// File upload constants
export const MAX_FILE_SIZE_MB = 10; // 10MB for images and documents
export const MAX_FILE_SIZE_BYTES = 10 * 1024 * 1024; // 10MB in bytes

/** Max exterior images; first image (index 0) is the listing thumbnail. */
export const EXTERIOR_MAX_IMAGES = 16;
export const EXTERIOR_MAX_REGULAR = EXTERIOR_MAX_IMAGES;

// Supported image types
export const SUPPORTED_IMAGE_TYPES = [
  "image/jpeg",
  "image/jpg",
  "image/png",
  "image/gif",
  "image/webp",
  // RAW formats
  "image/tiff", // RAW in TIFF format
  "image/x-canon-cr2", // Canon RAW
  "image/x-canon-crw", // Canon RAW
  "image/x-nikon-nef", // Nikon RAW
  "image/x-adobe-dng", // Adobe DNG
  "image/x-sony-arw", // Sony RAW
  "image/x-panasonic-rw2", // Panasonic RAW
  "image/x-fuji-raf", // Fuji RAW
  "image/x-olympus-orf", // Olympus RAW
  "image/x-pentax-pef", // Pentax RAW
  "image/x-samsung-srw", // Samsung RAW
  // HEIF/HEIC formats (iOS/Android)
  "image/heic", // HEIC format
  "image/heif", // HEIF format
];

// Supported document types
export const SUPPORTED_DOCUMENT_TYPES = [
  "application/pdf",
  "application/msword", // .doc
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
];

// All supported file types (images + documents)
export const SUPPORTED_FILE_TYPES = [
  ...SUPPORTED_IMAGE_TYPES,
  ...SUPPORTED_DOCUMENT_TYPES
];

// CDN / media URLs (e.g. CloudFront)
/** CDN base for support guide videos (CloudFront).
 * S3 stores at assets/videos/guides/{id}/{file} but CloudFront serves at guides/{id}/{file} */
export const SUPPORT_GUIDE_CDN_BASE =
  "https://d3fw4l8o9w552r.cloudfront.net/";

/** Public hero video on /how-it-works (S3 assets/videos/how-it-works.mp4 via CloudFront). */
export const HOW_IT_WORKS_HERO_VIDEO_URL = `${SUPPORT_GUIDE_CDN_BASE}how-it-works.mp4`;

/**
 * Convert S3 key to CloudFront CDN URL for support guide videos.
 * S3: assets/videos/guides/{id}/{file} → CloudFront: guides/{id}/{file}
 */
export function buildSupportGuideVideoUrl(s3Key: string): string {
  const cdnPath = s3Key.replace(/^assets\/videos\//, "");
  return SUPPORT_GUIDE_CDN_BASE + cdnPath;
}

/**
 * Normalize videoUrl from API – handles both legacy (assets/videos/guides/...)
 * and correct (guides/...) formats. CloudFront serves at guides/...
 */
export function normalizeSupportGuideVideoUrl(url: string | undefined): string | undefined {
  if (!url) return url;
  if (url.includes("/assets/videos/guides/")) {
    return url.replace("/assets/videos/guides/", "/guides/");
  }
  return url;
}

/** Max video size for support guides (100 MB) */
export const MAX_VIDEO_GUIDE_SIZE_MB = 100;
export const MAX_VIDEO_GUIDE_SIZE_BYTES = 100 * 1024 * 1024;
